import { doFetch } from "lib/doFetch";
import { getDispatch } from "app/StoreFactory";
import { miscSlice } from "redux/slices/miscSlice";
import { auditAddToReadingList } from "lib/analytics/auditEvents";

export const READING_LIST_URL = "/research/japi/user/reading-list";

export const addPubToReadingList = async (publication = {}) => {
  try {
    if (!publication.id) return;
    await doFetch(READING_LIST_URL, publication.id, "PUT");
    showReadingListNotification({ mode: "add", publication });
    addToLocalReadingList(publication);
    auditAddToReadingList(publication.id);
  } catch (err) {
    if (isDuplicate(err)) {
      showReadingListNotification({ mode: "duplicate", publication });
      console.warn("Item already in reading list", publication.id);
    } else if (isReadingListFull(err)) {
      showReadingListNotification({ mode: "reading-list-full", publication });
      console.warn("Reading list is full", publication.id);
    } else {
      showReadingListNotification({ mode: "add-error", publication });
      console.error("Cannot add item to reading list", publication.id, err);
    }
  }
};

export const removePubFromReadingList = async (publication = {}, setLoading) => {
  try {
    if (!publication.id) return;
    setLoading(true);
    await doFetch(READING_LIST_URL + "/" + publication.id, null, "DELETE");
    showReadingListNotification({ mode: "remove", publication });
    removeLocalReadingList(publication.id);
  } catch (err) {
    setLoading(false);
    showReadingListNotification({ mode: "remove-error", publication });
    console.error("Cannot remove item from reading list", publication.id, err);
  }
};

// show pop-up toast
function showReadingListNotification(props) {
  const dispatch = getDispatch();
  const notification = { key: "notifications", value: { ...props, type: "ReadingList", id: newId() } };
  dispatch(miscSlice.actions.push(notification));
}

// hide a pop-up toast
export function hideNotification(id) {
  const dispatch = getDispatch();
  const notificationToRemove = { key: "notifications", field: "id", value: id };
  dispatch(miscSlice.actions.removeElement(notificationToRemove));
}

// add to local reading list, refresh from server on page refresh
function addToLocalReadingList(publication) {
  const dispatch = getDispatch();
  dispatch(miscSlice.actions.push({ key: "readingList", value: publication }));
}

// remove from local (ui) reading list
function removeLocalReadingList(id) {
  const dispatch = getDispatch();
  dispatch(miscSlice.actions.removeElement({ key: "readingList", field: "id", value: id }));
}

const newId = () => Math.random();
const isDuplicate = (err) => err.toString().includes("Duplicate publication");
const isReadingListFull = (err) =>
  err.toString().includes("Maximum") && err.toString().includes("allowed in reading list");
